import { type FAQSection } from "../types/faq";

export const celestialFaqs: FAQSection[] = [
  {
    title: "General Questions",
    value: "general-questions",
    items: [
      {
        title: "What is the Celestial Client Experience Platform?",
        body: "The Celestial Client Experience Platform is a secure, centralized platform designed for Celestial's investors to access account information, investment performance data, statements, and important documents. The platform provides a streamlined, data-driven experience to help investors access data rooms and conduct diligence, subscribe to our funds, monitor their holdings, and engage with Celestial efficiently.",
      },
      {
        title: "Why did we launch this new portal?",
        body: "As part of Celestial's continued commitment to transparency, innovation, and operational excellence, we developed a new Client Experience Platform that delivers enhanced functionality, modern design, and improved performance. The new platform provides a more intuitive user experience, greater visibility into your investments, and faster access to the information you need.",
      },
      {
        title: "Who is the portal designed for?",
        body: "The Celestial Client Experience Platform is available to institutional investors, financial advisors, and individual investors (including identified proxies) who hold investments across Celestial-managed funds or vehicles.",
      },
      {
        title: "What are the key benefits I can expect?",
        body: `<ul class="list-disc list-inside space-y-1">
          <li>Portfolio dashboards and analytics</li>
          <li>Improved and secure document management</li>
          <li>Simplified navigation and mobile-friendly interface</li>
          <li>Streamlined onboarding and account management</li>
        </ul>`,
      },
      {
        title: "Is the portal replacing any previous systems?",
        body: "Yes. The Celestial Client Experience Platform consolidates and replaces all legacy Client Experience Platforms, offering one consistent experience for all investors. Any existing investor data and documents have been securely migrated to the new environment.",
      },
    ],
  },
  {
    title: "Access and Security",
    value: "access-and-security",
    items: [
      {
        title:
          "How do I gain access to the Celestial Client Experience Platform?",
        body: 'The Client Experience Platform will be accessible through any web browser via desktop or mobile device. After being invited by the Celestial team or one of your team members, you will receive an invitation email containing a secure link to register or log in to the platform. If you or a colleague did not receive an invitation, please reach out to <a href="mailto:celestial@vega.investments" class="text-brand/default hover:underline">celestial@vega.investments</a>.',
      },
      {
        title: "What credentials do I use to log in?",
        body: 'You will be able to log in to the new platform using the same credentials from the legacy Client Experience Platform. Should you have any issues logging in, please reach out to <a href="mailto:celestial@vega.investments" class="text-brand/default hover:underline">celestial@vega.investments</a>. If you have forgotten your password, click "Forgot Password" on the sign-in page to reset your credentials.',
      },
      {
        title: "Is my data secure?",
        body: "Yes. The portal leverages industry-standard encryption, multi-factor authentication, and advanced monitoring to protect investor information. Celestial adheres to strict cybersecurity and data privacy protocols across all systems, e.g. demonstrated by our SOC 2 Type 2 certification.",
      },
      {
        title: "Can multiple users from my organization have access?",
        body: "Yes. As many authorized users as you wish can be provisioned under a single investor account. User roles and permissions can be customized to allow multiple levels of access. You will be able to add contacts to your account directly in the portal or ask our support staff to do so on your behalf.",
      },
    ],
  },
  {
    title: "Using the Portal",
    value: "using-the-portal",
    items: [
      {
        title: "Can I access the portal on my mobile device?",
        body: "Yes. The portal is mobile-friendly and can be accessed through any supported web browser. A dedicated mobile app will be available soon.",
      },
      {
        title: "Can I download or export information?",
        body: "Yes. You can securely download account statements, notices, and performance reports directly from the portal.",
      },
      {
        title: "How often is information updated?",
        body: "Investment data and documentation are refreshed regularly based on fund reporting cycles. You will receive notifications when new statements or updates are available.",
      },
    ],
  },
  {
    title: "Migration and Transition",
    value: "migration-and-transition",
    items: [
      {
        title: "Do I need to take any action to transition to the new portal?",
        body: "Investors do not need to take any action—your account information and documents have been migrated automatically. If you have not previously registered, you will receive an activation email to complete setup.",
      },
      {
        title: "What happened to my previous portal access?",
        body: "Legacy Client Experience Platform links will redirect to the new Celestial Client Experience Platform. Please update your bookmarks to the new URL provided in your launch communication.",
      },
    ],
  },
  {
    title: "Support and Feedback",
    value: "support-and-feedback",
    items: [
      {
        title:
          "Who can I contact for support or to provide feedback on the portal?",
        body: 'For support and feedback on the portal, please email <a href="mailto:celestial@vega.investments" class="text-brand/default hover:underline">celestial@vega.investments</a>.',
      },
    ],
  },
];
